import { render, staticRenderFns } from "./AssignmentConf.vue?vue&type=template&id=5fa14968"
import script from "./AssignmentConf.vue?vue&type=script&lang=js"
export * from "./AssignmentConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports